module.exports = __webpack_public_path__ + "9b3d6efdca542eca9d9c0c9895e6ff57.png";